import { useEffect, useRef, useState } from 'react'
import Feather from '@sysunite/react-feather'
import { Tooltip, Input, Row, Col, Button, Switch } from 'antd'
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import './SearchGraphButton.scss'

SearchGraphButton = ({ onSearch }) ->
  [isOpen, setIsOpen] = useState(false)
  [value, setValue] = useState(undefined)
  [isTooltipVisible, setIsTooltipVisible] = useState(false)
  [showMisses, setShowMisses] = useState(false)
  inputRef = useRef()

  iconType = if isOpen then 'x' else 'search'

  classNames = ['search-graph']

  useEffect(->
    inputRef.current?.focus()
    ->
      setValue('')
  , [isOpen])

  if isOpen
    classNames.push('is-open')

  open = ->
    setIsOpen(!isOpen)

  <Tooltip visible={not isOpen and isTooltipVisible}
           placement="bottomLeft"
           trigger="hover"
           onVisibleChange={(visible) ->
             setIsTooltipVisible(visible)
           }
           mouseEnterDelay={1}
           title="Search in the graph">
    <div
      onContextMenu={(e) -> e.stopPropagation()}
      className={classNames.join(' ')}>
      <Row align="middle">
        <Col>
          <Button onClick={open} type="link" icon={<Feather size="1.5em" type={iconType}/>} />
        </Col>
        <Col style={{ flex: 1 }}>
          <Input
            ref={inputRef}
            value={value}
            onChange={({target: { value }}) -> setValue(value, !showMisses)}
            onPressEnter={({ target: { value }}) -> onSearch(value, !showMisses)}
            placeholder="Search in graph"
          />
        </Col>
        <Col>
          <Switch
            checked={showMisses}
            checkedChildren={<EyeOutlined />}
            unCheckedChildren={<EyeInvisibleOutlined />}
            onChange={(checked) -> setShowMisses(checked)}
          />
        </Col>
      </Row>
    </div>
  </Tooltip>

export default SearchGraphButton
